import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../../../Components/Navigation";
import { FaHome, FaUsers, FaBell, FaComments } from "react-icons/fa";
import { SkeletonList } from "../../Skeleton";
import API_URL from '../../../utils/api';
import "../../Dashboard/View/Dashboard.css";
export default function SearchingSessions() {
  const [sessions, setSessions] = useState([]);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  // Fetch user info
  useEffect(() => {
    const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
    if (userId) {
      fetch(`${API_URL}/api/users/${userId}`)
        .then(r => r.json())
        .then(data => {
          if (data.id) setUser(data);
        })
        .catch(err => {});
    }
  }, []);
  // Fetch waiting sessions
  useEffect(() => {
    const fetchSessions = () => {
      fetch(`${API_URL}/api/sessions`)
        .then(r => r.json())
        .then(data => {
          // Filter for sessions that are waiting for more people
          const waitingSessions = data.filter(s => {
            const isWaiting = s.status === 'waiting';
            const hasParticipants = s.participantCount > 0;
            const notFull = s.participantCount < (s.max_participants || 6);
            return isWaiting && hasParticipants && notFull;
          });
          setSessions(waitingSessions);
          setIsLoading(false);
        })
        .catch(err => {
          setIsLoading(false);
        });
    };
    fetchSessions();
    // Refresh every 5 seconds
    const interval = setInterval(fetchSessions, 5000);
    return () => clearInterval(interval);
  }, []);
  const handleJoinSession = async (sessionId) => {
    if (!user) {
      alert('Please log in to join a session');
      return;
    }
    try {
      const response = await fetch(`${API_URL}/api/sessions/${sessionId}/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: user.id,
          userName: user.name
        })
      });
      const data = await response.json();
      if (response.ok) {
        navigate(`/lobby/${sessionId}`);
      } else {
        alert(data.message || 'Failed to join session');
      }
    } catch (err) {
      alert('Failed to join session');
    }
  };
  return (
    <div className="dashboard-root">
      <Navigation user={user} />
      <div className="dashboard-content">
        {/* Sidebar */}
        <aside className="dashboard-sidebar">
          <SidebarIcon icon={<FaHome />} label="Home" />
          <SidebarIcon icon={<FaComments />} label="Sessions" active={true} />
          <SidebarIcon icon={<FaUsers />} label="Friends" />
          <SidebarIcon icon={<FaBell />} label="Notifications" />
        </aside>
        {/* Main Area */}
        <main className="dashboard-main">
          <h2 style={{ marginBottom: '20px', color: '#333' }}>Sessions Waiting for Participants</h2>
          <div className="dashboard-sessions" style={{ display: 'grid', gap: '15px' }}>
            {isLoading && <SkeletonList count={3} />}
            {!isLoading && sessions.length === 0 && (
              <div style={{ 
                padding: '40px', 
                textAlign: 'center', 
                color: '#999',
                background: '#f9f9f9',
                borderRadius: '12px'
              }}>
                No sessions are currently waiting for participants.
              </div>
            )}
            {!isLoading && sessions.map(s => (
              <div className="session-card" key={s.id} style={{
                background: 'white',
                padding: '20px',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div className="session-info">
                  <div className="session-name" style={{ 
                    fontSize: '1.2rem', 
                    fontWeight: '600', 
                    color: '#333',
                    marginBottom: '8px'
                  }}>
                    {s.name}
                  </div>
                  <div className="session-host" style={{ 
                    color: '#666', 
                    fontSize: '0.9rem',
                    marginBottom: '4px'
                  }}>
                    Host: {s.host}
                  </div>
                  <div style={{ 
                    color: '#ff7b95', 
                    fontSize: '0.85rem',
                    fontWeight: '600'
                  }}>
                    {s.participantCount} / {s.max_participants || 6} participants
                  </div>
                </div>
                <button 
                  onClick={() => handleJoinSession(s.id)}
                  style={{
                    background: 'linear-gradient(135deg, #ff7b95, #ff4c6d)',
                    color: 'white',
                    border: 'none',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                  onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  Join Session
                </button>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
function SidebarIcon({ icon, label, active }) {
  const navigate = useNavigate();
  const handleClick = () => {
    if (label === "Home") {
      navigate("/dashboard");
    } else if (label === "Sessions") {
      navigate("/sessions-searching");
    }
  };
  return (
    <div 
      className={`sidebar-icon ${active ? 'active' : ''}`}
      onClick={handleClick} 
      style={{ cursor: label === "Home" || label === "Sessions" ? "pointer" : "default" }}
    >
      {icon}
      <span className="sidebar-label">{label}</span>
    </div>
  );
}
